import type { PageBlockDefinition } from '../definition-types'

export const rankedListDefinition: PageBlockDefinition = {
  type: 'ranked-list',
  label: 'Ranked List',
  description: 'Numbered recommendation list that supports static or feed content.',
  rowCompatible: false,
  columnCompatible: true,
  category: 'editorial',
  minArticles: 3,
  maxArticles: 10,
  slots: [],
  defaultConfig: {
    sectionHeaderEnabled: false,
    sectionHeaderTitle: null,
    sectionHeaderStyle: 'rule-left',
    numberingStyle: 'numeric',
    showSummary: false,
    showFooterAction: false,
    footerActionLabel: 'Explore More',
  },
  editorFields: [
    { key: 'sectionHeaderEnabled', label: 'Show Section Header', type: 'toggle' },
    { key: 'sectionHeaderTitle', label: 'Section Header Title', type: 'text' },
    {
      key: 'sectionHeaderStyle',
      label: 'Section Header Style',
      type: 'select',
      options: [
        { label: 'Rule Left', value: 'rule-left' },
        { label: 'All Caps', value: 'all-caps' },
        { label: 'Plain', value: 'plain' },
      ],
    },
    {
      key: 'numberingStyle',
      label: 'Numbering Style',
      type: 'select',
      options: [
        { label: 'Numeric', value: 'numeric' },
        { label: 'Pill', value: 'pill' },
        { label: 'Minimal', value: 'minimal' },
      ],
    },
    { key: 'showSummary', label: 'Show Summary', type: 'toggle' },
    { key: 'showFooterAction', label: 'Show Footer Action Link', type: 'toggle' },
    { key: 'footerActionLabel', label: 'Footer Action Label', type: 'text' },
  ],
}
